/* eslint-disable prefer-spread */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';
declare const rdt: any;
import { RawEvent } from '../../../interface/eventInterface';
import { getExternalId } from '../../conversionAPI';
import { Tracker } from '../trackers';
export class RedditTracker implements Tracker {
  private pixelIDs: string[];

  constructor(pixelIDs: string[]) {
    if (pixelIDs.length === 0) {
      console.error('[RedditTracker] Constructor: No pixel IDs provided.');
      throw new Error('RedditTracker requires at least one pixel ID.');
    }
    this.pixelIDs = pixelIDs;
    console.debug(
      '[RedditTracker] Constructor: Initialized with pixel IDs:',
      this.pixelIDs,
    );
  }

  Init(): void {
    console.debug('[RedditTracker] Init: Starting pixel initialization.');
    try {
      this.initializePixels();
    } catch (error) {
      console.error(
        '[RedditTracker] Init: Failed to initialize pixels:',
        error,
      );
    }
  }

  private initializePixels() {
    console.debug(
      '[RedditTracker] initializePixels: Injecting Reddit Pixel script.',
    );

    try {
      (function (w: any, d: any) {
        if (!w.rdt) {
          console.debug(
            '[RedditTracker] initializePixels: Creating rdt object.',
          );
          const p = (w.rdt = function () {
            (p as any).sendEvent
              ? (p as any).sendEvent.apply(p, arguments)
              : (p as any).callQueue.push(arguments);
          });
          (p as any).callQueue = [];
          const t = d.createElement('script');
          t.src = 'https://www.redditstatic.com/ads/pixel.js';
          t.async = true;
          t.onload = function () {
            console.log(
              '[RedditTracker] initializePixels: Reddit Pixel script loaded successfully.',
            );
          };
          t.onerror = function () {
            console.error(
              '[RedditTracker] initializePixels: Failed to load Reddit Pixel script.',
            );
          };

          const s = d.getElementsByTagName('script')[0];
          s.parentNode!.insertBefore(t, s);
        } else {
          console.debug(
            '[RedditTracker] initializePixels: rdt object already exists.',
          );
        }
      })(window, document);

      // Initialize each Reddit Pixel after script loads
      const initInterval = setInterval(() => {
        if (typeof rdt === 'function') {
          clearInterval(initInterval);
          this.pixelIDs.forEach(pixelID => {
            console.debug(
              `[RedditTracker] initializePixels: Initializing pixel ID: ${pixelID}`,
            );
            try {
              // rdt('init', pixelID, {
              //   external_id: getExternalId(),
              // });
              // console.log(
              //   `[RedditTracker] initializePixels: Pixel ${pixelID} initialized successfully.`,
              // );
            } catch (error) {
              console.error(
                `[RedditTracker] initializePixels: Error initializing pixel ID: ${pixelID}`,
                error,
              );
            }
          });
        }
      }, 100);

      // Timeout after 5 seconds if script doesn't load
      setTimeout(() => {
        if (typeof rdt !== 'function') {
          console.error(
            '[RedditTracker] initializePixels: Reddit pixel script failed to load within timeout.',
          );
        }
      }, 5000);
    } catch (error) {
      console.error(
        '[RedditTracker] initializePixels: Error during script injection:',
        error,
      );
    }
    this.pixelIDs.forEach((pixelID, index) => {
      rdt('init', pixelID);
      console.log(index, `[RedditTracker] Pixel ${pixelID} initialized.`);
    });
  }

  TrackEvent(event: RawEvent): void {
    console.debug('[RedditTracker] TrackEvent: Received event:', event);

    try {
      if (typeof rdt !== 'function') {
        console.warn(
          '[RedditTracker] TrackEvent: rdt function not available. Reddit pixel may not have loaded.',
        );
        return;
      }

      this.pixelIDs.forEach(pixelID => {
        const baseParams = {
          external_id: event?.externalId || getExternalId(),
          conversion_id: event?.conversionId,
        };
        console.debug('[RedditTracker] TrackEvent: Received event:', event);

        try {
          switch (event.eventName) {
            case 'ShippingAdded':
              break;
            case 'Purchase':
              console.log(
                `[RedditTracker] Attempting to track Purchase for ${pixelID}`,
              );
              rdt('track', 'Purchase', {
                value: event.cart?.TotalAmount,
                currency: event?.cart?.currencyCode || 'USD',
                item_count: event.cart?.LineItems?.length || 0,
                products: event.cart?.LineItems?.map(item => ({
                  id: item?.ProductID,
                  category: item?.Category,
                  name: item?.Name,
                })),
                ...baseParams,
              });
              console.log(`[RedditTracker] Purchase tracked for ${pixelID}`);
              break;

            // case 'Search':
            //   rdt('track', 'Search', {
            //     search_string: event?.searchQuery,
            //     ...baseParams,
            //   });
            //   break;

            // case 'ViewContent':
            //   rdt('track', 'ViewContent', baseParams);
            // //   break;
            case 'PageView':
              console.log(
                `[RedditTracker] Attempting to track PageVisit for ${pixelID}`,
              );
              rdt('track', 'PageVisit', baseParams);
              console.log(
                `[RedditTracker] PageVisit event sent for pixel ${pixelID}`,
              );
              break;
            default:
              rdt('track', 'Custom', {
                customEventName: event.eventName,
                value: event.cart?.TotalAmount || 0,
                currency: event?.cart?.currencyCode || 'USD',
                ...baseParams,
              });
              break;
            // case 'PageVisit':
            //   rdt('track', 'PageVisit', baseParams);
            //   console.log(`[RedditTracker] PageVisit tracked for ${pixelID}`);
            //   break;
          }
        } catch (error) {
          console.error(
            `[RedditTracker] TrackEvent: Failed to track event for pixel ID: ${pixelID}`,
            error,
          );
        }
      });
    } catch (error) {
      console.error('[RedditTracker] TrackEvent: Error tracking event:', error);
    }
  }
}
